import dropzoneReducers from './dropzone-slice';

export default {
  ...dropzoneReducers,
};

export * from './dropzone-slice';
